
/*
    Mutations
    the only place we can modify/update the state (store.js)
*/

let  mutations = {

    // Update product details
    UPDATE_PRODUCT_DETAILS( state, obj){
        const sizesArray = [];
        const reviewsArray = [];

        // Create sizes array by removing Firebase default Key
        for(let key in obj.sizes){
            sizesArray.push(obj.sizes[key])
        }

        // Create reviews array by removing Firebase default Key
        for(let i in obj.reviews){
            reviewsArray.push(obj.reviews[i])
        }


        // Update state
        state.product.title = obj.content.title;
        state.product.hardness = obj.content.firmness;
        state.product.description = obj.content.body;

        state.product.price = `$${obj.content.price}`;
        state.product.promo = `$${obj.content.promo}`;
        state.product.sizes = sizesArray;

    },


    // Update product review average
  UPDATE_PRODUCT_REVIEW_AVERAGE(state, obj) {
        state.product.review.score = obj.results[0].rollup.average_rating;
        state.product.review.votes = obj.results[0].rollup.review_count;
        state.product.review.recommended_ratio = (obj.results[0].rollup.recommended_ratio * 100) + '%';

    },


    // Update product reviews
    UPDATE_PRODUCT_REVIEWS( state, obj){

        state.product.reviews.push(...obj.results[0].reviews)

    },

};

export default mutations;



// WEBPACK FOOTER //
// ./src/vuex/mutations.js